import * as ActionTypes from './types.action';

export const startEditingBasketItem = (meal, uuid, origin) => ({
  type: ActionTypes.RESET_BASKET_ITEM_SUCCESS,
  meal,
  uuid,
  origin
});

export const updateBasketItemSize = size => ({
  type: ActionTypes.UPDATE_BASKET_ITEM_SIZE_SUCCESS,
  size
});

export const updateBasketItemOptions = mealOptions => ({
  type: ActionTypes.UPDATE_BASKET_ITEM_OPTIONS_SUCCESS,
  mealOptions
});

export const resetBasketItemOriginalState = () => ({
  type: ActionTypes.RESET_BASKET_ITEM_ORIGINAL_STATE_SUCCESS
});

export const loadExistingBasketItem = basketItem => ({
  type: ActionTypes.LOAD_EXISTING_BASKET_ITEM_SUCCESS,
  basketItem
});

export const updateBasketItemComments = comments => ({
  type: ActionTypes.UPDATE_BASKET_ITEM_COMMENTS_SUCCESS,
  comments
});



// WEBPACK FOOTER //
// ./actions/basketItem.action.js